const FETCH_MULTI_BANNER_LIST_INFO = 'fetchMultiBannerListInfo'
// const FETCH_MULTI_BANNER_LIST_INFO_RANDOM = 'random'
const LOGIN = 'login'
const LOGOUT = 'logout'
const SET_MULTI_BANNER_LIST_BY_UI_CODE = 'setMultiBannerListByUiCode'
const FETCH_BAND_INFO = 'fetchBandInfo'

export { FETCH_MULTI_BANNER_LIST_INFO, LOGIN, LOGOUT, SET_MULTI_BANNER_LIST_BY_UI_CODE, FETCH_BAND_INFO }
